import { render, staticRenderFns } from "./DynAttrs.vue?vue&type=template&id=0287fe9c&scoped=true&"
import script from "./DynAttrs.vue?vue&type=script&lang=js&"
export * from "./DynAttrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0287fe9c",
  null
  
)

export default component.exports